import styled from "styled-components";

export const ClickableComponentWrapper = styled.button`
  display: flex;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;
